import { CallingQueue } from './CallingQueue';
import { RemitToQueue } from './RemitToQueue';

const ApCallingQueueRoute = {
  path: '/accounting/apcallingqueue',
  load: () => import('./ApCallingQueue'),
  protected: true,
};

// ts-unused-exports:disable-next-line
export { ApCallingQueueRoute, CallingQueue, RemitToQueue };
